import classNames from 'classnames';
import { useState } from 'react';

import { SectionDivider } from '../../../../components/Section/SectionDivider';
import { SectionHeader } from '../../../../components/Section/SectionHeader';
import { Button } from '../../../../components/UI/Button';
import { formatDate } from '../../../../lib/date-helpers';
import { toMoney } from '../../../../lib/number-formatter';
import { useSelector } from '../../../../redux/hooks';
import { selectors as invoiceSelectors } from '../../../../redux/modules/invoice';
import { INVOICE_STATUS_DESCRIPTION } from '../constants';
import styles from './PaymentHistory.module.scss';

const cx = classNames.bind(styles);

export function PaymentHistory() {
    const paymentHistory = useSelector(invoiceSelectors.selectPaymentHistoryData);
    const [rowCount, setRowCount] = useState(12);

    function handleRowCount() {
        setRowCount(rowCount + 6);
    }

    return (
        <>
            <div className={styles.paymentHistoryWrapper}>
                <SectionHeader className={styles.sectionHeader} header="PAYMENT HISTORY" />
                <SectionDivider />
                <div className={styles.paymentHistoryContent}>
                    {paymentHistory
                        .slice(0, rowCount)
                        .map(({ due_date, id, status, total }, index) => {
                            return (
                                <div className={styles.row} key={`${id}-${index}`}>
                                    <div className={styles.cell}>
                                        {formatDate(due_date, 'MMM dd yyyy')}
                                    </div>
                                    <div className={styles.cell}>
                                        {INVOICE_STATUS_DESCRIPTION[status]}
                                    </div>
                                    <div className={styles.cell}>{toMoney(total)}</div>
                                    <div className={cx(styles.cell, styles['cell--view'])}>
                                        <Button
                                            className={styles.view}
                                            colour="white"
                                            label="View"
                                            onClick={() => {
                                                const invoiceUrl = new URL(
                                                    `${window.origin}/invoice/${id}`
                                                );

                                                window.open(invoiceUrl.toString(), '_blank');
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
            {paymentHistory.length > rowCount && (
                <div className={styles.loadMoreButtonWrapper}>
                    <Button className={styles.button} label="Load More" onClick={handleRowCount} />
                </div>
            )}
        </>
    );
}
